import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppLayout from "./AppLayout/AppLayout";
import BuilderRoutes from "./BuilderRoutes/BuilderRoutes";
import CustomerRoutes from "./CustomerRoutes/CustomerRoutes";
import LandingRoutes from "./LandingRoutes/LandingRoutes";
import MasterDataPage from "../pages/MasterDataPage"; // Import the new page

const Routing = () => {
  return (
    <BrowserRouter>
      <AppLayout>
        <Routes>
          {/* Add the Master Data route */}
          <Route path="/master-data/:projectId" element={<MasterDataPage />} />

          {/* Landing routes */}
          <Route path="/*" element={<LandingRoutes />} />
          {/* Customer routes with /customer prefix */}
          <Route path="/customer/*" element={<CustomerRoutes />} />
          {/* Builder routes */}
          <Route path="/builder/*" element={<BuilderRoutes />} />
        </Routes>
      </AppLayout>
    </BrowserRouter>
  );
};

export default Routing;
